import React from 'react'
import { observer } from 'mobx-react-lite'
import {
  MDBBtn,
  MDBIcon,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
} from 'mdb-react-ui-kit'
import ActivityStore from './../shared/stores/activity.store'

import './InactivityTimer.scss'
import { useEffect } from 'react'

const CHECK_INTERVAL_MS = 45000

const InactivityTimer = () => {
  useEffect(() => {
    const runCheck = () => {
      if (document.visibilityState === 'visible') ActivityStore.checkActivity()
    }

    document.addEventListener('visibilitychange', runCheck)
    window.addEventListener('focus', runCheck)
    window.addEventListener('pageshow', runCheck)

    const interval = setInterval(runCheck, CHECK_INTERVAL_MS)

    return () => {
      document.removeEventListener('visibilitychange', runCheck)
      window.removeEventListener('focus', runCheck)
      window.removeEventListener('pageshow', runCheck)
      clearInterval(interval)
    }
  }, [])
  return (
    <MDBModal
      id='InactivityTimerComponent'
      open={ActivityStore.showWarningModal}
      tabIndex='-1'
      onClose={ActivityStore.cancelWarning}
    >
      <MDBModalDialog size='md'>
        <MDBModalContent>
          <MDBModalHeader>
            <MDBModalTitle>
              <MDBIcon icon='exclamation-triangle' />
              &nbsp;<h4>You are about to be logged out!</h4>
            </MDBModalTitle>
            <MDBBtn type='button' className='btn-close' color='none' onClick={ActivityStore.cancelWarning}></MDBBtn>
          </MDBModalHeader>
          <MDBModalBody>
            <strong>You have been inactive for an hour.</strong>
            <br />
            You will be logged out in <strong>{ActivityStore.remaining}</strong> seconds.
            <br />
            <MDBBtn type='button' color='default' block onClick={ActivityStore.cancelWarning}>
              Stay Logged In
            </MDBBtn>
          </MDBModalBody>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  )
}

export default observer(InactivityTimer)
